import { call, put, takeLeading, all, takeEvery } from 'redux-saga/effects'
import {
  updateCurrentTask,
  updateRequestData,
  setInitPdfProcessError,
  setRunPdfTaskStart,
  setRunPdfTaskSuccess,
  mcbqs020RunningProcess,
  setProjectData,
  initPdfProcess,
} from 'reducers/setOutputPdfProcessReducer'

import {
  initRequest,
  selectionFileRequest,
  mcbFileRequest,
  applicantDetailRequest,
  shlTestResultRequest,
  pdfMergeRequest,
} from 'apis/MCBQS020Api'
import { openModal, openModalWithArg } from 'reducers/messageReducer'

const tasks = [
  {
    name: '選考ファイル',
    action: selectionFileRequest,
    targetField: 'selectionFileMergeTargetInfo' as const,
  },
  {
    name: 'MCBファイル',
    action: mcbFileRequest,
    targetField: 'mcbFileMergeTargetInfo' as const,
  },
  {
    name: '応募者詳細PDF',
    action: applicantDetailRequest,
    targetField: 'applicantPdfMergeTargetInfo' as const,
  },
  {
    name: '適性テスト結果',
    action: shlTestResultRequest,
    targetField: 'shlTestResultMergeTargetInfo' as const,
  },
  {
    name: 'ファイル結合',
    action: pdfMergeRequest,
    targetField: null,
  },
]

function* initPdfProcessSaga(action: ReturnType<typeof initPdfProcess>) {
  try {
    const setPrintManagementId = action.payload.setPrintManagementId
    const response = yield call(initRequest, { setPrintManagementId })
    yield put(setProjectData(response));
  } catch (error) {
    yield put(setInitPdfProcessError(error.message))
  }
}

function* runPdfTaskSaga(action: ReturnType<typeof mcbqs020RunningProcess>) {
  try {
    let currentData = action.payload
    yield put(setRunPdfTaskStart())

    for (let i = 0; i < tasks.length; i++) {
      const task = tasks[i]

      yield put(updateCurrentTask({ index: i, name: task.name }))
      const response = yield call(task.action, currentData)
      if (typeof response === 'string') {
        const messResult: Array<string> = response.split(",");
        if (messResult.length == 1) {
          yield put(openModal(messResult[0]))
        } else {
          const [messageId, ...args] = messResult
          const mergedArgs = args.join(", ");
          yield put(openModalWithArg({ messageId, args: [mergedArgs] }))
        }
        return;
      }

      if (task.targetField) {
        currentData = {
          ...currentData,
          [task.targetField]: response,
        }
      }

      const newFlag = (parseInt(currentData.screenDisplayToggleFlag || '0') + 1).toString()
      currentData = {
        ...currentData,
        screenDisplayToggleFlag: newFlag,
      }

      yield put(updateRequestData(currentData))
    }

    yield put(setRunPdfTaskSuccess())
  } catch (error) {
    yield put(openModal(error.message))
  }
}

export default function* setOutputPdfProcessSaga() {
  yield all([
    takeEvery(initPdfProcess, initPdfProcessSaga),
    takeLeading(mcbqs020RunningProcess, runPdfTaskSaga),
  ])
}
